/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import CloseIcon from "@mui/icons-material/Close";
import {
    Autocomplete,
    Box,
    Button,
    Chip,
    FormControl,
    FormControlLabel,
    IconButton,
    InputLabel,
    MenuItem,
    Modal,
    Select,
    Switch,
    TextField,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useForm } from "src/shared/hooks/useForm";
import { selectMainState, useSelector } from "src/stateManagement/redux";
import DeleteIcon from '@mui/icons-material/Delete';
import { StatusConditions, TypesOfActivities } from "src/stateManagement/redux/slices/shared/interfaces";
import EditIcon from '@mui/icons-material/Edit';
import { DesktopDatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import InfoIcon from '@mui/icons-material/Info';
import { Tooltip } from '@mui/material';
import { normalizeText } from "src/shared/util/normalizeText";

interface Props {
    TabDisable: boolean;
    open: boolean;
    setOpen: any;
    requirements: any[];
    setRequeriments: any;
}

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    gap: 2,
    p: 4,
};

export const Requirements = ({
    TabDisable,
    setOpen,
    open,
    requirements,
    setRequeriments,
}: Props) => {
    const { locationName, lastStatusConditions, optimizationRequirements: currentRequirements } = useSelector((state: any) => state.location);

    const { configModules } = useSelector(selectMainState);

    const [typesActivities, setTypesActivities] = useState<TypesOfActivities[]>([])

    const [statusConditions, setStatusConditions] = useState<StatusConditions[]>([])

    const [optimizationActivitiesStates, setOptimizationActivitiesStates] = useState<any[]>([])

    const [formValues, handleInputChange, reset, setNuewValues] = useForm({
        type: "",
        comments: "",
        status: "pending",
        isWellWithMultiplesTDSEntries: false,
        simulationDate: undefined,
        targetProduction: undefined,
        lastProduction: undefined
    });

    const [listActiveBloquers, setlistActiveBloquers] = useState<any>([])

    const [enableOptions, setEnableOptions] = useState<string[]>([])

    useEffect(() => {

        if (Array.isArray(configModules?.typesActivitiesForOptimization)) {
            setTypesActivities(configModules?.typesActivitiesForOptimization)
        }
        if (Array.isArray(configModules?.statusConditions)) {
            setStatusConditions(configModules?.statusConditions)
        }

        if (Array.isArray(configModules?.optimizationActivitiesStates)) {

            const filtedStates = configModules?.optimizationActivitiesStates?.filter((state: any) => state?.type?.includes("Requirement"))

            setOptimizationActivitiesStates(filtedStates)
        }

    }, [configModules])

    useEffect(() => {

        const blockers = []

        const types = type.split(',').map((item: string) => item.trim())

        if (types.length === 0) {
            setlistActiveBloquers([]);
            return;
        }

        for (const typeOfAction of types) {
            const typeActivity = typesActivities.find(
                (activity: any) => activity.label === typeOfAction
            );
            const values: any = { ...lastStatusConditions }

            for (const blocker of typeActivity?.deppendOf || []) {
                const statusBlocker = statusConditions.find(
                    (status: any) => status.field === blocker
                )?.warningStatus;

                if (statusBlocker?.includes(values[blocker])) {
                    blockers.push(blocker)
                }
            }
        }

        setlistActiveBloquers(blockers)
    }, [formValues])

    useEffect(() => {

        const enableOptionsFiltered = []

        for (const activity of typesActivities) {
            const exist = currentRequirements.find(
                (requirement: any) => requirement.variableId === activity.id && requirement.status === "pending"
            );
            if (!exist) {
                enableOptionsFiltered.push(activity.label)
            }
        }
        setEnableOptions(enableOptionsFiltered);
    }, [typesActivities])

    const { type, comments, status, simulationDate, targetProduction, lastProduction, isWellWithMultiplesTDSEntries } = formValues;

    const columns: GridColDef[] = [
        { field: "location", headerName: "Locación", flex: 1 },
        {
            field: "name",
            headerName: "Requerimiento",
            flex: 1,
        },
        { field: "comments", headerName: "Comentario", flex: 1 },
        { field: "isWellWithMultiplesTDSEntries", headerName: "El pozo es repetitivo", flex: 1, renderCell: (params) => (params.value ? "Sí" : "No") },
        {
            field: "actions",
            headerName: "",
            width: 100,

            renderCell: (params) => {
                return (
                    <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
                        <IconButton
                            color="error"
                            onClick={() => handleDeleteRequirement(params.row.id)}
                            size="small"
                        >
                            <DeleteIcon />
                        </IconButton>
                        <IconButton
                            size="small"
                            color="primary"
                            onClick={() => handleEditRow(params.row)}
                        >
                            <EditIcon fontSize="medium" />
                        </IconButton>
                    </Grid>
                );
            },
        },
    ];

    const paginationModel = { page: 0, pageSize: 10 };

    const handleClose = () => {
        setOpen(false)
        reset();
    };

    const handleAddRequirement = () => {

        console.log("Adding requirement with values:")

        const blocker = listActiveBloquers?.map((blocker: any, index: number) => {
            const values: any = { ...lastStatusConditions }
            const statusBlocker = statusConditions.find(
                (status: any) => status.field === blocker
            );

            return { [String(statusBlocker?.name)]: values[blocker] }
        })

        const types = type.split(',').map((item: string) => item.trim())

        const otherRequirements = requirements.filter(r => ![...types].includes(r.name))

        const data = []

        for (const typeOfAction of types) {
            const element = typesActivities.find(
                (activity: any) => normalizeText(activity.label) === normalizeText(typeOfAction)
            );

            data.push({
                id: element?.id,
                location: locationName,
                name: typeOfAction,
                value: "Si",
                type: "Optimization",
                comments,
                blocker,
                status,
                simulationDate,
                targetProduction,
                lastProduction,
                isWellWithMultiplesTDSEntries,
            })
        }

        // TODO: Uncomment this block if you want to prevent adding requirements when there are blockers
        // if (blocker?.length > 0) {
        //     Swal.fire({
        //         title: "Existen bloqueantes para esta actividad, no puede ser programada continuar.",
        //         text: "",
        //         icon: "error",
        //         confirmButtonColor: "#3085d6",
        //         confirmButtonText: "Entendido",
        //         customClass: {
        //             title: "sweat_alert_title"
        //         }
        //     });
        //     return;
        // }

        setRequeriments([...data, ...otherRequirements]);
        reset();
        setOpen(false);
    };

    const handleDeleteRequirement = (id: string) => {
        const newRequirements = requirements.filter(
            (requirement: any) => requirement.id !== id
        );
        setRequeriments(newRequirements);
    };

    const handleEditRow = (row: any) => {
        setNuewValues({
            type: row.name,
            comments: row.comments,
            status: row.status,
            simulationDate: row.simulationDate,
            targetProduction: row.targetProduction,
            lastProduction: row.lastProduction,
            isWellWithMultiplesTDSEntries: row.isWellWithMultiplesTDSEntries || false,
        })
        setOpen(true);
    }

    return (
        <Grid container spacing={0}>
            {/* table */}
            <Grid size={12}>
                <DataGrid
                    rows={requirements}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[10, 20, 50, 100]}
                    checkboxSelection={false}
                    sx={{
                        border: 0,
                        mt: 2,
                        "& .MuiDataGrid-columnHeader": {
                            backgroundColor: "#316EBC",
                            color: "#fff",
                            fontWeight: "bold",
                        },
                    }}
                    getRowId={(row) => row.id}
                />
            </Grid>
            {/* Modal */}
            <Modal
                open={open}
                onClose={handleClose}
            >
                <Box sx={style}>
                    {/* Modal header button */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            mb: 2,
                        }}
                    >
                        <IconButton
                            aria-label="delete"
                            onClick={handleClose}
                            sx={{
                                backgroundColor: "#cf1919",
                                color: "#fff",
                                "&:hover": {
                                    backgroundColor: "#ff3535",
                                },
                                width: 30,
                                height: 30,
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Grid sx={{ padding: 1 }}>
                        <InputLabel id="demo-simple-select-label">
                            Tipo de Actividad
                        </InputLabel>
                        <Autocomplete
                            multiple
                            id="size-small-standard-multi"
                            size="small"
                            options={enableOptions}
                            value={type !== "" ? type?.split(',').map((item: string) => (item !== "" && item.trim())) : []}
                            onChange={(event: any, newValue: any) => {
                                setNuewValues({
                                    ...formValues,
                                    type: newValue.join(',')
                                })
                            }}
                            sx={{
                                // border: "1px solid rgba(0, 0, 0, 0.23)",
                                borderRadius: "4px",
                                padding: "1px 1px",
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                />
                            )}
                        />
                    </Grid>
                    <Grid sx={{ padding: 1 }}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label">
                                Estado
                            </InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                label="Tipo de Actividad"
                                id="demo-simple-select"
                                name="status"
                                value={status}
                                onChange={handleInputChange}
                                size="small"
                            >
                                {/* <MenuItem value=""></MenuItem> */}
                                {optimizationActivitiesStates.map((state: any, index) => {
                                    return (
                                        <MenuItem
                                            value={state.id}
                                            key={index}
                                        >
                                            {state.name}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid
                        sx={{
                            display: "flex",
                            padding: "5px 0px",
                            border: "1px solid rgba(0, 0, 0, 0.23)",
                            borderRadius: "4px",
                            marginRight: 1,
                            marginLeft: 1
                        }}
                    >
                        <FormControl fullWidth>
                            <FormControlLabel
                                label={"Pozo repetitivo :"}
                                labelPlacement="start"
                                control={
                                    <Switch
                                        checked={isWellWithMultiplesTDSEntries}
                                        onChange={(event) => handleInputChange({
                                            target: {
                                                name: "isWellWithMultiplesTDSEntries",
                                                value: event.target.checked,
                                            }
                                        })}
                                    />
                                }
                                sx={{
                                    flex: 1,
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            />
                        </FormControl>
                        {/* TODO Tooltip with TDS */}
                        {/* <Tooltip
                            title={
                                <>
                                    20-05-2025 cambio de bomba
                                    <br />
                                    20-05-2025 cambio de diseño
                                </>
                            }
                            arrow
                        >
                        <IconButton
                            size="small"
                            color="info"
                            sx={{marginLeft: 3}}
                            onClick={() => {}}
                        >
                            <InfoIcon fontSize="medium" />
                        </IconButton>
                        </Tooltip> */}
                    </Grid>
                    <Grid sx={{ padding: 1, display: "flex", alignItems: "center" }}>
                        <DesktopDatePicker
                            defaultValue={null}
                            label="Fecha Simulación"
                            name="simulationDate"
                            value={simulationDate ? moment(simulationDate) : null}
                            onChange={(event) => {
                                const formattedDate = moment(event).format("YYYY-MM-DD");
                                handleInputChange({
                                    target: {
                                        name: "simulationDate",
                                        value: formattedDate,
                                    }
                                });
                            }}
                            sx={{
                                width: "100%",
                            }}
                        />
                        <IconButton
                            size="small"
                            color="warning"
                            disabled={!simulationDate}
                            onClick={() => {
                                handleInputChange({
                                    target: {
                                        name: "simulationDate",
                                        value: null,
                                    }
                                });
                            }}
                        >
                            <RemoveCircleIcon fontSize="medium" />
                        </IconButton>
                    </Grid>
                    <Grid sx={{ padding: 1 }}>
                        <TextField
                            fullWidth
                            size="medium"
                            name="targetProduction"
                            label="Última Medida (BBPD)"
                            value={targetProduction || 0}
                            onChange={(e) => {
                                const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                handleInputChange({
                                    target: {
                                        name: "targetProduction",
                                        value: numericValue,
                                    }
                                });
                            }}
                        />
                    </Grid>
                    <Grid sx={{ padding: 1 }}>
                        <TextField
                            fullWidth
                            size="medium"
                            name="lastProduction"
                            label="Ganancial Estimado (BBPD)"
                            value={lastProduction || 0}
                            onChange={(e) => {
                                const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                handleInputChange({
                                    target: {
                                        name: "lastProduction",
                                        value: numericValue,
                                    }
                                });
                            }}
                        />
                    </Grid>
                    <TextField
                        fullWidth
                        size="small"
                        label="Comentario"
                        multiline
                        rows={4}
                        sx={{ mt: 2 }}
                        value={comments}
                        name="comments"
                        onChange={handleInputChange}
                    />
                    {/* save button */}
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        size="small"
                        sx={{ mt: 2 }}
                        onClick={handleAddRequirement}
                    >
                        Agregar
                    </Button>
                </Box>
            </Modal>
        </Grid>
    );
};
